// extracted by mini-css-extract-plugin
export default {"overlay":"IdleWarning_overlay__bsQ-p","message":"IdleWarning_message__0ovkq","icon":"IdleWarning_icon__1yaGr","seconds":"IdleWarning_seconds__BQsrG"};